import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#a65f01',
                secondary: '#fbfad7',
            }
        }
        
    }
});
